import { render, staticRenderFns } from "./EGCompany.vue?vue&type=template&id=5075b284&scoped=true&"
import script from "./EGCompany.vue?vue&type=script&lang=js&"
export * from "./EGCompany.vue?vue&type=script&lang=js&"
import style0 from "./EGCompany.vue?vue&type=style&index=0&id=5075b284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5075b284",
  null
  
)

export default component.exports